/* eslint-disable */
import axios from "axios";


export const base = process.env.VUE_APP_BASE_URL_FLOCKER_UAT

export const authUrl =  base;
export const flocker =  base+"/index.php";
export const uploads =  base+"/uploads/";

// Hard cap: every API call must either resolve or fail within REQUEST_TIMEOUT_MS. Without this
// axios waits forever, which combined with PHP's set_time_limit(0) means a single stuck DB query
// freezes the UI with no error and no recovery. 15s is generous for normal calls; M-Pesa STK
// initiation occasionally takes longer and has its own polling pattern after the initial response.
const REQUEST_TIMEOUT_MS = 15000;

export const execute = (params, url) => {
    const tokenStr = localStorage.getItem("authToken"); // Get token dynamically
    return axios.post(url, params, {
        headers: { "Authorization": `Bearer ${tokenStr}` },
        timeout: REQUEST_TIMEOUT_MS
    })
}

export const executeJson = (params, url) => {
    const tokenStr = localStorage.getItem("authToken"); // Get token dynamically
    return axios.post(url, params, {
        headers: {
            "Authorization": `Bearer ${tokenStr}`,
            "Content-Type": "application/json" // Specify JSON content type
        },
        timeout: REQUEST_TIMEOUT_MS
    });
}




export const executeDownload = (params, url) => {
    const tokenStr = localStorage.getItem("authToken");
    return axios.post(url, params, {
        headers: { "Authorization": `Bearer ${tokenStr}` },
        responseType: 'blob',
        timeout: REQUEST_TIMEOUT_MS
    })
}
export const execute2 = (params, url) => {
    return axios.post(url, params, { timeout: REQUEST_TIMEOUT_MS })
}
export const getRight = (accessRole) => {
    // Get the string from sessionStorage and parse it into an array
    const selectedRolesString = sessionStorage.getItem("selectedRoles");

    if (!selectedRolesString) {
        //  console.error("selectedRoles is not available in sessionStorage");
        return false;  // or handle the absence of selectedRoles in sessionStorage
    }

    try {
        const selectedRoles = JSON.parse(selectedRolesString);

        if (!Array.isArray(selectedRoles)) {
            //  console.error("selectedRoles is not an array");
            return false;  // or handle the case where selectedRoles is not an array
        }

        let accessRight = false;

        for (const role of selectedRoles) {
            //  console.log(`${accessRole} role: ${role.role}`);
            if (role.role === accessRole) {
                accessRight = true;
                break;  // no need to continue checking once a match is found
            }
        }

        return accessRight;
    } catch (error) {
        //  console.error("Error parsing selectedRoles:", error);
        return false;  // or handle the error appropriately
    }
};

